module.exports = __webpack_public_path__ + "assets/img/nongyeFlow.2dfc53f1.png";